// noinspection ES6UnusedImports
import Vue from 'vue'
import axios from 'axios'
import store from '../store'

axios.defaults.baseURL = process.env.VUE_APP_API
// axios.defaults.baseURL = 'http://localhost:11111/'
// axios.defaults.baseURL = "https://demo.elabsinc.com/api/"
axios.defaults.headers.common.Accept = 'application/json'
axios.interceptors.response.use(
  response => response,
  (error) => {
    console.log(error)
    if (error.response.status === 401) {
      return new Promise((resolve) => {
        /*
        store.dispatch('auth/refresh')
          .then((token) => {
            let config = error.config
            config.headers.Authorization = `Bearer ${token.accessToken}`
            return resolve(axios(config))
          })
          .catch(() => {
            store.dispatch('auth/logout').then(() => {
              location.reload()
            })
          })
          */
        store.dispatch('auth/logout').then(() => {
          location.reload()
        })
      })
    }
    return Promise.reject(error)
  }
)

Vue.$http = axios
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return axios
  }
})
